/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-08 08:19:34
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-01-25 09:43:51
 * @FilePath: /wemeet-web-activity/src/pages/tickets/hooks/time.ts
 * @Description: 票务里面活动时间显示，场次票，显示当前场次时间
 */
import { useMemo, useState, useCallback } from 'react';
import { activityTimeFormat } from "../utils/index";
const getInitTime = activityInfo => {
  const [showTime, setShowTime] = useState('-1');
  const realTime = useMemo(() => {
    let time = showTime;
    if (showTime === '-1' && activityInfo) {
      time = activityTimeFormat(activityInfo.start_time, activityInfo.end_time);
    }
    return time;
  }, [showTime, activityInfo]);
  const resetTicketTime = useCallback((startTime, endTime) => {
    if (startTime) {
      const dateTime = activityTimeFormat(startTime, endTime);
      setShowTime(dateTime);
      return;
    }
    setShowTime('-1');
  }, []);
  return [realTime, resetTicketTime];
};
export default getInitTime;